import { SchemaOf, object, string, boolean } from 'yup';

import { SupportFileSettings } from './types';

export function validationSchema(): SchemaOf<SupportFileSettings> {
  return object({
    passwordProtect: boolean().default(false),
    password: string()
      .default('')
      .when('passwordProtect', {
        is: true,
        then: (schema) => schema.required('This field is required.'),
      }),
  });
}
